import * as React from "react";
import { Table } from "components/bootstrap";
import { NoEntitiesExist } from "components/common";
import { randomHexString } from "security-app/components/common/helperFunctions";
import { NoEntitiesExistWrapper } from "../shared";
function PortList({ ports }) {
  if (!ports || ports.length === 0) {
    return /* @__PURE__ */ React.createElement(NoEntitiesExistWrapper, null, /* @__PURE__ */ React.createElement(NoEntitiesExist, null, "No ports reported"));
  }
  return /* @__PURE__ */ React.createElement(Table, { condensed: true, "aria-label": "Ports list" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Port"), /* @__PURE__ */ React.createElement("th", null, "Protocol"))), /* @__PURE__ */ React.createElement("tbody", null, ports.map(({ port, protocol }) => /* @__PURE__ */ React.createElement("tr", { key: randomHexString(12) }, /* @__PURE__ */ React.createElement("td", null, port), /* @__PURE__ */ React.createElement("td", null, protocol)))));
}
export default PortList;
